module.exports = {
  dev: {
    keycloakUrl: 'https://sso.aeris-data.fr/auth/realms/formater',
    clientId: 'geodesy-plotter-vjs',
    method: 'public'
  },
//  dev: {
//    clientId: 'geodesy-plotter',
//    sso: 'formater',
//    method: 'apache',
//    lifetime: 600, // 10 minutes
//    authUrl: 'https://spotgins.formater/userinfo',
//    refreshUrl: 'https://spotgins.formater/userinfo',
//    userinfoUrl: 'https://spotgins.formater/userinfo' ,
//    logoutUrl: 'https://spotgins.formater/logout'
//  },
  prod: {
    keycloakUrl: 'https://sso.aeris-data.fr/auth/realms/formater',
    clientId: 'geodesy-plotter-vjs',
    method: 'public'
  }
}